/** Post SEO: title, description, og image, canonical, noindex, URL + a Google result preview. */
import React from 'react';
import { Alert, Button, Checkbox, Form, Input, Typography } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../../shared/i18n';
import CoverPicker from './CoverPicker';

const { Text } = Typography;
const cut = (s, n) => (s.length > n ? `${s.slice(0, n - 1)}…` : s);

const SeoPanel = ({ siteId, p, set, url, siteHost, slugChanged, live, onSuggest, suggesting }) => {
    const { t } = useTranslation();
    const seo = p.seo || {};
    const setSeo = (patch) => set({ seo: { ...seo, ...patch } });
    const title = seo.title || p.title || '';
    const desc = seo.description || p.excerpt || '';
    return (
        <>
            <div style={{ border: '1px solid var(--ant-color-border-secondary, #f0f0f0)', borderRadius: 8, padding: 12, marginBottom: 12 }} data-testid="google-preview">
                <div style={{ fontSize: 12, color: 'var(--ant-color-text-tertiary, #666)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{url || `${siteHost} › blog`}</div>
                <div style={{ fontSize: 18, color: '#1a0dab', lineHeight: 1.3, margin: '2px 0' }}>{cut(title, 60) || t('Page title')}</div>
                <div style={{ fontSize: 13, opacity: 0.8, lineHeight: 1.45 }}>{cut(desc, 155) || t('Meta description')}</div>
            </div>
            <Button size="small" icon={<ThunderboltOutlined />} loading={suggesting} onClick={onSuggest} style={{ marginBottom: 12 }}>{t('Suggest SEO')}</Button>
            <Form layout="vertical">
                <Form.Item label={t('Page title')} extra={<Text type={title.length > 60 ? 'warning' : 'secondary'} style={{ fontSize: 12 }}>{title.length}/60</Text>}>
                    <Input value={seo.title} maxLength={255} placeholder={p.title} onChange={(e) => setSeo({ title: e.target.value })} />
                </Form.Item>
                <Form.Item label={t('Meta description')} extra={<Text type={desc.length > 155 ? 'warning' : 'secondary'} style={{ fontSize: 12 }}>{desc.length}/155</Text>}>
                    <Input.TextArea value={seo.description} maxLength={500} autoSize={{ minRows: 2 }} placeholder={p.excerpt} onChange={(e) => setSeo({ description: e.target.value })} />
                </Form.Item>
                <Form.Item label={t('URL handle')}>
                    <Input addonBefore="/blog/" value={p.slug} onChange={(e) => set({ slug: e.target.value.replace(/\s+/g, '-') }, true)} />
                </Form.Item>
                {live && slugChanged && <Alert style={{ marginBottom: 12 }} type="info" showIcon message={t('The old URL will redirect to the new one (301) after you update the post and publish the site')} />}
                <Form.Item label={t('Social share image')}>
                    <CoverPicker siteId={siteId} src={seo.image} onChange={(m) => setSeo({ image: m?.url || '' })} />
                </Form.Item>
                <Form.Item label={t('Canonical URL')}>
                    <Input value={seo.canonical} placeholder="https://" maxLength={1000} onChange={(e) => setSeo({ canonical: e.target.value })} />
                </Form.Item>
                <Checkbox checked={!!seo.noindex} onChange={(e) => setSeo({ noindex: e.target.checked })}>{t('Hide from search engines (noindex)')}</Checkbox>
            </Form>
        </>
    );
};

export default SeoPanel;
